export default "__VITE_ASSET__e9na955___"